import { change } from 'redux-form'

export default function (form, url, publicId) {
  return json => dispatch => {
    dispatch(change(form, url, json.url))
    dispatch(change(form, publicId, json.public_id))
  }
}
